import { slideDown, slideUp } from '../../js/shared/utils';


(function () {
    const accordions = document.querySelectorAll('.js-accordion');
    const speedAnimation = 400;

    accordions.forEach((accordion) => {
        const elems = accordion.querySelectorAll('.js-accordion-item');

        elems.forEach((el) => {
            const btnToggle = el.querySelector('.js-accordion-btn-toggle');
            const elContent = el.querySelector('.js-accordion-content');
            const elText = el.querySelector('.js-accordion-text');

            if (!elContent && !elText && !btnToggle) {
                return;
            }

            function btnClick() {
                if (!el.classList.contains('is-active')) {
                    // console.log(`slideDown`);

                    elems.forEach((otherEl) => {
                        if (otherEl !== el) {
                            otherEl.classList.remove('is-active');
                            slideUp(otherEl.querySelector('.js-accordion-content'), speedAnimation, btnToggle);
                        }
                    });

                    el.classList.add('is-active');
                    slideDown(elContent, speedAnimation, btnToggle);
                } else {
                    //console.log(`slideUp`);

                    el.classList.remove('is-active');
                    slideUp(elContent, speedAnimation, btnToggle);
                }
            }

            btnToggle.addEventListener('click', btnClick);

        });

    });
})();

